module.exports = __webpack_public_path__ + "img/psychologicalTests.7dd56834.png";